import { render, staticRenderFns } from "./wtFaceOnCameraCountdown.vue?vue&type=template&id=7b6f5997&scoped=true&"
import script from "./wtFaceOnCameraCountdown.vue?vue&type=script&lang=js&"
export * from "./wtFaceOnCameraCountdown.vue?vue&type=script&lang=js&"
import style0 from "./wtFaceOnCameraCountdown.vue?vue&type=style&index=0&id=7b6f5997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f5997",
  null
  
)

export default component.exports